/**
 * How the uniform-structure instructions write a date on screen.
 *
 * §5.4 shows the period as DDMMYYYY, with no separators. That is a display
 * rule only: the file itself stores YYYYMMDD, and nothing here touches it.
 */
export function openFormatDisplayDate(isoDate: string): string {
  const [year = '', month = '', day = ''] = isoDate.split('-');
  return `${day}${month}${year}`;
}

/**
 * When a run was produced, read back out of its own path.
 *
 * `OPENFRMT\<8 digits>.<YY>\<MMDDhhmm>` already states the year, the day and
 * the minute, and it is the server's clock that wrote them. Taking the
 * summary's "DD/MM/YY at hh:mm" from the path means the sentence cannot name
 * a minute other than the one in the folder the files sit in.
 */
export function openFormatProducedAt(path: string): { date: string; time: string } | null {
  const match = /\.(\d{2})\\(\d{2})(\d{2})(\d{2})(\d{2})$/.exec(path);
  if (!match) return null;
  const [, year, month, day, hour, minute] = match;
  return { date: `${day}/${month}/${year}`, time: `${hour}:${minute}` };
}
